import React from "react";
import { ActivityItem } from "../../types";

interface RecentActivityProps {
  data: ActivityItem[];
  type?: string; 
}

export const RecentActivity: React.FC<RecentActivityProps> = () => {
  return (
    <div className="bg-white dark:bg-gray-900 rounded-lg p-6 shadow-sm border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">
        Recent Activity
      </h3>
      <div className="space-y-4">
        No Rcent Activities
      </div>
    </div>
  );
};
